import type {SearchQueryResponseData} from '../queries/searchQuery';
import type {SearchParamsType} from '../reducers/searchParams';

/* @flow */
export const SEARCH_QUERY_COMPLETE = 'SEARCH_QUERY/COMPLETE';
export const SEARCH_QUERY_START = 'SEARCH_QUERY/START';

type SearchQueryStartActionType = 'SEARCH_QUERY/START';
type SearchQueryCompleteActionType = 'SEARCH_QUERY/COMPLETE';

export type SearchQueryCompleteAction = {
    type: SearchQueryCompleteActionType,
    payload: SearchQueryResponseData
};

export type SearchQueryStartAction = {
    type: SearchQueryStartActionType,
    payload: SearchParamsType
};

export type Action = SearchQueryCompleteAction | SearchQueryStartAction;

const ACTION_CREATORS = {
    searchQueryComplete(
        data: SearchQueryResponseData
    ): SearchQueryCompleteAction {
        return {
            type: SEARCH_QUERY_COMPLETE,
            payload: data
        };
    },
    searchQueryStart(data: SearchParamsType): SearchQueryStartAction {
        return {
            type: SEARCH_QUERY_START,
            payload: data
        };
    }
};

export default {...ACTION_CREATORS};
